// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__wmYzJ","modalForm":"UpgradeEpcsModal_modalForm__CoS0k","modalFooter":"UpgradeEpcsModal_modalFooter__1Tg-g"};